import React from "react";

const SpecialProgressChartForKPI03 = ({ kpi }) => {
  const getProgressBar = (label, value, colorClass) => {
    const percentage = value ? Math.round(value) : 0;
    return (
      <div className="col-12 mt-4" key={label}>
        <div className="d-flex justify-content-between">
          <h6>{percentage}%</h6>
          <span>{label}</span>
        </div>
        <div className="progress">
          <div
            className={`progress-bar ${colorClass}`}
            style={{ width: `${percentage}%` }}
          ></div>
        </div>
      </div>
    );
  };
  

  return (
    <div style={{ padding: 20, background: "#f9f9f9", borderRadius: 8 }}>
      <h5 style={{ textAlign: "center", marginBottom: 20 }}>{kpi.kpi_code}</h5>
      <div className="row">
        {getProgressBar("Avg Target", kpi.avg_target_performance, "bg-primary")}
        {getProgressBar("Avg Actual", kpi.avg_actual_performance, "bg-success")}
        {getProgressBar("Internal Benchmark", kpi.avg_internal_benchmark, "bg-info")}
        {getProgressBar("External Benchmark", kpi.avg_external_benchmark, "bg-warning")}
        {getProgressBar("New Target", kpi.avg_new_target_performance, "bg-danger")}
      </div>
    </div>
  );
};

export default SpecialProgressChartForKPI03;
